import React, { ReactNode, useState } from 'react';
import styled, { css } from 'styled-components';
import { ArrowDown16 } from '@honeybook/icons';
import HBAccordionNew from '../HBAccordionNew/HBAccordionNew';
import HBText from '../HBText/HBText';

interface Props {
    /** Additional CSS class applied to the accordion root container. */
    className?: string;
    /** When true, the section starts expanded on initial render. Defaults to collapsed (false). */
    defaultOpen?: boolean;
    /** Form fields or other content rendered inside the collapsible section. */
    children: ReactNode;
    /** Text shown on the toggle trigger that expands or collapses the section. */
    title: string;
}

const FIXED_VALUE = 'fixed_value';

const HBFormCollapsibleSection = ({
    className,
    defaultOpen,
    children,
    title
}: Props) => {
    const [accordionValue, setAccordionValue] = useState<string>(
        defaultOpen ? FIXED_VALUE : ''
    );

    const isOpen = accordionValue === FIXED_VALUE;

    return (
        <HBAccordionNew.Root
            type="single"
            collapsible
            value={accordionValue}
            onValueChange={setAccordionValue}
            className={className}
        >
            <HBAccordionNew.Item value={FIXED_VALUE}>
                <HBAccordionNew.Trigger testIdName={'more-details-block'}>
                    <HBText type="emphasis14">
                        <span>{title}</span>
                        <StyledArrowDown16 isOpen={isOpen} />
                    </HBText>
                </HBAccordionNew.Trigger>
                <HBAccordionNew.Content>{children}</HBAccordionNew.Content>
            </HBAccordionNew.Item>
        </HBAccordionNew.Root>
    );
};

export default HBFormCollapsibleSection;

// -------------------------- Styles -------------------------- //

const StyledArrowDown16 = styled(ArrowDown16)<{ isOpen: boolean }>`
    display: inline-flex;
    vertical-align: middle;
    margin-left: 2px;
    transform: rotate(0deg);
    ${({ isOpen }) =>
        isOpen &&
        css`
            transform: rotate(-180deg);
        `}
    svg * {
        fill: currentColor;
    }
`;
